import { createContext, useState } from "react";

const ItemsReadyForReturnContext = createContext({
  itemsReadyForReturn: [],
  setItemsReadyForReturn: (currentItemBeingReturned: any) => {},
});

const ItemsReadyForReturnContextProvider = ({ children }) => {
  const [itemsReadyForReturn, setItemsReadyForReturn] = useState([]);

  return (
    <ItemsReadyForReturnContext.Provider
      value={{ itemsReadyForReturn, setItemsReadyForReturn }}
    >
      {children}
    </ItemsReadyForReturnContext.Provider>
  );
};

export { ItemsReadyForReturnContext, ItemsReadyForReturnContextProvider };
